import Vue from 'vue'
import keyGuideBox from './kye-guide.vue'
import { isDOM, RELATIVE_POSITION_CLASS, getPropValue } from './utils'

const KyeGuideConstructor = Vue.extend(keyGuideBox)

export const KYE_GUIDE_VERSION = 'KYE_GUIDE_VERSION_'

const createKyeGuideOverLay = (parent) => {
  const overlay = document.createElement('div')
  // 如果是弹窗 首先查看父级是否有定位，没有则添加相对定位，
  // 同时遮罩为绝对定位设置为 top.left为0
  const isDialog = parent.classList.contains('el-dialog__body')
  const className = isDialog ? 'kye-guide-overlay-absolute' : 'kye-guide-overlay'

  if (isDialog) {
    const parentPosition = getPropValue(parent, 'position')
    if (
      parentPosition !== 'absolute' &&
      parentPosition !== 'relative' &&
      parentPosition !== 'sticky' &&
      parentPosition !== 'fixed'
    ) {
      parent.classList.add(RELATIVE_POSITION_CLASS)
    }
  }
  overlay.classList.add(className)
  // 如果存在则不再添加了
  if (document.querySelector('.' + className)) {
    return className
  }
  parent.appendChild(overlay)
  return className
}
const createKyeGuide = function(options) {
  return new Promise((resolve, reject) => {
    let instance
    instance = new KyeGuideConstructor({
      el: document.createElement('div')
    })

    let { version = '', appendTo = null } = options
    if (!version) {
      reject(new Error('请传入版本号!!!'))
      return
    }
    if (appendTo) {
      if (typeof appendTo === 'string') {
        appendTo = document.querySelector(appendTo)
      } else if (appendTo.$el) {
        appendTo = appendTo.$el
      }
    }
    if (appendTo && !isDOM(appendTo)) {
      reject(new Error('appendTo的类型应该为DOM或者css选择器!!!'))
      return
    }
    const parent = appendTo || document.querySelector('.main-panel>div')
    instance.id = this.$store.state.user.id + '_' || ''
    const getVersion = localStorage.getItem(KYE_GUIDE_VERSION + instance.id + version) || ''
    // 属性合并
    for (let prop in options) {
      if (options.hasOwnProperty(prop)) {
        instance[prop] = options[prop]
      }
    }


    // 默认追加到main下渲染的路由下
    // 如果已经存在就不再创建了
    const className = KYE_GUIDE_VERSION + version
    const isExitGuideDom = document.querySelector('.' + className)
    !isExitGuideDom && parent && parent.appendChild(instance.$el)

    instance['parent'] = parent

    const isVisible = getVersion !== version
    // 创建遮罩层
    if (isVisible) {
      instance['overlayClassName'] = createKyeGuideOverLay(parent)
    }
    Vue.nextTick(() => {
      // 打开弹窗
      instance.visible = isVisible
    })
    resolve(instance)
  })
}

export default createKyeGuide
export { createKyeGuide }



// WEBPACK FOOTER //
// ./src/public/components/kye-guide/kye-guide.js